import { motion } from 'framer-motion';

// "CHERRY HILLS" — CHERRY in brand gold, HILLS in brand green.
// Each letter rises and falls in a wave that runs continuously.
const LETTERS = [
  ...'CHERRY'.split('').map((ch, i) => ({ ch, gold: true, delay: i * 0.075 })),
  { ch: ' ', gold: false, delay: 6 * 0.075 },
  ...'HILLS'.split('').map((ch, i) => ({ ch, gold: false, delay: (7 + i) * 0.075 })),
];

const LoadingScreen = ({ slow = false, onRetry }) => (
  <motion.div
    exit={{ opacity: 0, scale: 1.04 }}
    transition={{ duration: 0.55, ease: 'easeInOut' }}
    // Above everything, including the hero's falling-notes overlay (z-9999),
    // so the money only appears once the splash has faded out.
    className="fixed inset-0 z-[10000] bg-[#0A1628] flex flex-col items-center justify-center px-6"
  >
    {/* Wordmark */}
    <div className="flex items-center justify-center flex-wrap select-none" aria-label="Cherry Hills">
      {LETTERS.map(({ ch, gold, delay }, i) =>
        ch === ' ' ? (
          <span key={i} className="w-4 sm:w-6" />
        ) : (
          <span
            key={i}
            className="ch-letter font-serif font-bold text-3xl sm:text-5xl md:text-6xl"
            style={{
              color: gold ? '#D9A441' : '#2D9F5D',
              animationDelay: `${delay}s`,
              textShadow: '0 0 28px rgba(217,164,65,0.18)',
            }}
          >
            {ch}
          </span>
        )
      )}
    </div>

    <p className="mt-4 text-[10px] sm:text-xs font-bold tracking-[0.34em] uppercase text-[#8EA0B5]">
      Portfolio Management Ltd.
    </p>

    {/* Progress shimmer */}
    <div className="mt-10 w-40 h-1 rounded-full bg-white/10 overflow-hidden">
      <div className="ch-shimmer h-full w-1/2 rounded-full" />
    </div>

    {/* Poor internet notice */}
    {slow && (
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        className="mt-10 max-w-sm w-full bg-white/[0.06] border border-white/10 rounded-2xl px-6 py-5 text-center"
      >
        <div className="flex items-center justify-center gap-2 mb-2">
          <i className="ri-wifi-line text-[#D9A441]" />
          <span className="text-sm font-bold text-white">Poor internet connection</span>
        </div>
        <p className="text-xs leading-relaxed text-[#9FB0C3]">
          We're still trying to load the latest information. This may take a little longer on a
          slow connection.
        </p>
        <button
          onClick={onRetry}
          className="mt-4 px-6 py-2.5 rounded-full bg-[#F2652D] hover:bg-[#D95A28] text-white text-xs font-bold uppercase tracking-widest transition-colors cursor-pointer"
        >
          Retry
        </button>
      </motion.div>
    )}
  </motion.div>
);

export default LoadingScreen;